module.exports = __webpack_public_path__ + "static/media/statistics.c5a3dbba.svg";